// extracted by mini-css-extract-plugin
export var backdropBlur = "_k6-0";
export var contentCard = "_k6-5";
export var frame = "_k6-2";
export var image = "_k6-4";
export var imagePane = "_k6-3";
export var modal = "_k6-1";